


















import { defineComponent, onMounted, ref } from 'vue';
import { bizSceneCheck } from '~mall/model/apis/bike';
import nativeMgr, { CityInfo } from '~mall/common/native/native';
import { showThirdPage } from '~mall/common/utils/jumpUrl';

export default defineComponent({
  name: 'BottomConsentAgreement',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    categoryName: {
      type: String,
      default: '',
    },
    textColorStyle: {
      type: String,
      default: '',
    },
  },
  emits: ['handleUpdateBottomTip'],
  setup(props, { emit }) {
    const location = ref<CityInfo | null>({});
    const rightInfo = ref<string>('');
    const rightInfoUrl = ref<string>('');

    const handleAgreementClick = () => {
      if (rightInfoUrl.value) {
        // if (isHelloFamilyApp) {
        //   Native.callNative({
        //     classMap: 'NavBar',
        //     method: 'setStatusBar',
        //     params: { isShowStatusBar: true },
        //   });
        //   Native.callNative({
        //     classMap: 'NavBar',
        //     method: 'setStatusBarColor',
        //     params: { isShowStatusBar: true, isDarkFont: false, colorCode: '#ffffff' },
        //   });
        // }
        showThirdPage(rightInfoUrl.value);
      }
    };

    const fetchAccessInfo = async () => {
      const params = {
        adCode: location.value?.adCode,
        cityCode: location.value?.cityCode,
        sceneType: 'purchaseAgreement',
        businessType: props.categoryName === '单车' ? 1 : 2,
        channelCode: props.categoryName === '单车' ? 101000 : 102000,
        version: (await nativeMgr.getDeviceInfo()).version,
      };
      const { agreementInfo: { gray, clickUrl, title } } = await bizSceneCheck(params);
      emit('handleUpdateBottomTip', gray);
      rightInfo.value = title;
      rightInfoUrl.value = clickUrl;
    };

    const cityFetch = async () => {
      const res = await nativeMgr.getCityInfo();
      location.value = res;
    };

    onMounted(async () => {
      await cityFetch();
      if (!location.value) return;
      fetchAccessInfo();
    });

    return {
      location,
      rightInfo,
      rightInfoUrl,
      handleAgreementClick,
    };
  },
});
